import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, normalizeClass as _normalizeClass, createVNode as _createVNode, createTextVNode as _createTextVNode, withCtx as _withCtx, unref as _unref, openBlock as _openBlock, createBlock as _createBlock } from "vue"

const _hoisted_1 = ["src"]

import { Form } from 'vee-validate';
import { ref } from 'vue';
import IButton from '@/js/components/molecules/IButton.vue';
import ITextArea from '@/js/components/molecules/ITextArea.vue';


export default /*@__PURE__*/_defineComponent({
  __name: 'ImageComment',
  props: {
    url: {},
    text: { default: '' }
  },
  emits: ["cancel", "save"],
  setup(__props: any, { emit: __emit }) {

const props = __props;
const emit = __emit;
const comment = ref(props.text);
const cancel = () => {
  comment.value = props.text;
  emit('cancel');
};
const save = () => {
  emit('save', comment.value);
};

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createBlock(_unref(Form), { as: "div" }, {
    default: _withCtx(({ errors }) => [
      _createElementVNode("p", {
        class: _normalizeClass(_ctx.$style.commentImage)
      }, [
        _createElementVNode("img", {
          src: _ctx.url,
          width: "100%"
        }, null, 8, _hoisted_1)
      ], 2),
      _cache[4] || (_cache[4] = _createTextVNode()),
      _cache[5] || (_cache[5] = _createElementVNode("p", null, [
        _createElementVNode("strong", null, "この画像へのコメント")
      ], -1)),
      _cache[6] || (_cache[6] = _createTextVNode()),
      _createVNode(ITextArea, {
        modelValue: comment.value,
        "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((comment).value = $event)),
        name: "comment",
        rows: 4,
        rules: "max:300"
      }, null, 8, ["modelValue"]),
      _cache[7] || (_cache[7] = _createTextVNode()),
      _createElementVNode("div", {
        class: _normalizeClass(_ctx.$style.commentBtn)
      }, [
        _createVNode(IButton, { onClick: cancel }, {
          default: _withCtx(() => _cache[1] || (_cache[1] = [
            _createTextVNode("キャンセル")
          ])),
          _: 1
        }),
        _cache[3] || (_cache[3] = _createTextVNode()),
        _createVNode(IButton, {
          type: "primary",
          disabled: Boolean(errors.comment),
          onClick: save
        }, {
          default: _withCtx(() => _cache[2] || (_cache[2] = [
            _createTextVNode("保存")
          ])),
          _: 2
        }, 1032, ["disabled"])
      ], 2)
    ]),
    _: 1
  }))
}
}

})